import React from 'react';

import { ToastProvider } from './toast';
import { UserProvider } from './user';
import { CepProvider } from './cep';

const AppProvider: React.FC = ({ children }) => (
  <ToastProvider>
    <UserProvider>
      <CepProvider>{children}</CepProvider>
    </UserProvider>
  </ToastProvider>
);

export default AppProvider;
